// extracted by mini-css-extract-plugin
module.exports = {"title":"viewnote_title__1-u5k","view_other":"viewnote_view_other__3UNLS","addBtn":"viewnote_addBtn__ORm4F","text":"viewnote_text__1CnaD","noteText":"viewnote_noteText__1xnfg"};